<template>
  <div class="prode-mundial">
      <!-- Header -->
      <v-card class="header-card" dark>
        <v-card-title class="justify-center flex-column pa-3">
          <div class="text-h6 text-sm-h5 font-weight-bold text-center">
            ⚽ MUNDIAL 2026 - FIXTURE & RANKING
          </div>
          <div class="text-caption text-center mt-1" style="opacity: 0.8;">
            Estados Unidos · México · Canadá
          </div>
        </v-card-title>
      </v-card>

      <!-- Tabs: Fixture / Posiciones / Ranking -->
      <v-tabs v-model="tabActiva" background-color="blue darken-2" dark centered show-arrows grow>
        <v-tab>Fixture</v-tab>
        <v-tab>Posiciones</v-tab>
        <v-tab>Ranking</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tabActiva">
        <!-- TAB FIXTURE -->
        <v-tab-item>
          <v-card flat class="pa-2">
            <!-- Selector de grupo -->
            <div class="d-flex flex-wrap justify-center mb-2" style="gap: 4px;">
              <v-btn
                v-for="grupo in grupos"
                :key="'f'+grupo"
                :color="grupoFixture === grupo ? 'blue darken-2' : 'grey lighten-2'"
                :dark="grupoFixture === grupo"
                x-small depressed class="grupo-btn"
                @click="grupoFixture = grupo"
              >
                {{ grupo }}
              </v-btn>
            </div>

            <div class="text-subtitle-2 font-weight-bold text-center mb-2 blue--text text--darken-2">
              GRUPO {{ grupoFixture }}
            </div>

            <v-simple-table dense class="tabla-fixture">
              <thead>
                <tr>
                  <th class="text-center" style="width: 30px;">#</th>
                  <th>Fecha</th>
                  <th class="text-right">Local</th>
                  <th class="text-center" style="width: 60px;">Res.</th>
                  <th>Visitante</th>
                  <th class="hidden-xs-only">Sede</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(p, idx) in partidosFixtureGrupo" :key="idx">
                  <td class="text-center">{{ p.idresultado }}</td>
                  <td class="text-caption">{{ p.fechaPartido }}</td>
                  <td class="text-right font-weight-medium">{{ p.equipo1 }}</td>
                  <td class="text-center font-weight-bold">
                    <span v-if="p.goles1Real !== null && p.goles1Real !== ''">
                      {{ p.goles1Real }} - {{ p.goles2Real }}
                    </span>
                    <span v-else class="grey--text">vs</span>
                  </td>
                  <td class="font-weight-medium">{{ p.equipo2 }}</td>
                  <td class="text-caption hidden-xs-only">{{ p.sede }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </v-tab-item>

        <!-- TAB POSICIONES -->
        <v-tab-item>
          <v-card flat class="pa-2">
            <div class="d-flex flex-wrap justify-center mb-2" style="gap: 4px;">
              <v-btn
                v-for="grupo in grupos"
                :key="'p'+grupo"
                :color="grupoPosiciones === grupo ? 'blue darken-2' : 'grey lighten-2'"
                :dark="grupoPosiciones === grupo"
                x-small depressed class="grupo-btn"
                @click="grupoPosiciones = grupo"
              >
                {{ grupo }}
              </v-btn>
            </div>

            <div class="text-subtitle-2 font-weight-bold text-center mb-2 blue--text text--darken-2">
              GRUPO {{ grupoPosiciones }}
            </div>

            <v-simple-table dense>
              <thead>
                <tr>
                  <th>Equipo</th>
                  <th class="text-center">Pts</th>
                  <th class="text-center">PJ</th>
                  <th class="text-center">PG</th>
                  <th class="text-center">PE</th>
                  <th class="text-center">PP</th>
                  <th class="text-center">GF</th>
                  <th class="text-center">GC</th>
                  <th class="text-center">Dif</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(eq, idx) in posicionesGrupo" :key="idx">
                  <td class="font-weight-medium">{{ eq.nombre }}</td>
                  <td class="text-center font-weight-bold">{{ eq.puntaje }}</td>
                  <td class="text-center">{{ eq.pj }}</td>
                  <td class="text-center">{{ eq.pg }}</td>
                  <td class="text-center">{{ eq.pe }}</td>
                  <td class="text-center">{{ eq.pp }}</td>
                  <td class="text-center">{{ eq.gf }}</td>
                  <td class="text-center">{{ eq.gc }}</td>
                  <td class="text-center">{{ eq.gf - eq.gc }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </v-tab-item>

        <!-- TAB RANKING -->
        <v-tab-item>
          <v-card flat class="pa-2">
            <div class="text-subtitle-2 font-weight-bold text-center mb-2 red--text">
              RANKING PRODE
            </div>

            <v-simple-table dense>
              <thead>
                <tr>
                  <th class="text-center" style="width: 40px;">#</th>
                  <th>Nombre</th>
                  <th class="text-center">Puntos</th>
                  <th class="text-center" style="width: 40px;"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(r, idx) in ranking" :key="idx">
                  <td class="text-center font-weight-bold">{{ idx + 1 }}</td>
                  <td>{{ r.nombre }} <span style="font-size:10px; color:#999;">({{ r.legajo }})</span></td>
                  <td class="text-center font-weight-bold blue--text">{{ r.puntos }}</td>
                  <td class="text-center">
                    <v-icon small color="blue" @click="verProde(r)">mdi-eye</v-icon>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </v-tab-item>
      </v-tabs-items>

      <!-- Dialog: Ver prode de un participante -->
      <Informe2026 :visible="showProde" :legajo="legajoVer" @close="showProde = false" />
  </div>
</template>

<script>
import axios from "../../../axios-auth";
import Informe2026 from "./Informe2026.vue";

export default {
  name: "ProdeFixture2026",
  components: { Informe2026 },

  data() {
    return {
      tabActiva: 0,
      grupos: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"],
      grupoFixture: "A",
      grupoPosiciones: "A",
      fixture: [],
      posiciones: [],
      ranking: [],
      showProde: false,
      legajoVer: "",
    };
  },

  computed: {
    partidosFixtureGrupo() {
      return this.fixture.filter((p) => p.grupo === this.grupoFixture);
    },
    posicionesGrupo() {
      return this.posiciones.filter((p) => p.grupo === this.grupoPosiciones);
    },
  },

  mounted() {
    this.cargarFixture();
    this.cargarPosiciones();
    this.cargarRanking();
  },

  methods: {
    cargarFixture() {
      axios
        .get("/App/GetFixture2026")
        .then((r) => { this.fixture = r.data || []; })
        .catch(() => { this.fixture = []; });
    },

    cargarPosiciones() {
      axios
        .get("/App/GetPosiciones2026")
        .then((r) => { this.posiciones = r.data || []; })
        .catch(() => { this.posiciones = []; });
    },

    cargarRanking() {
      axios
        .get("/App/GetRanking2026")
        .then((r) => { this.ranking = r.data || []; })
        .catch(() => { this.ranking = []; });
    },

    verProde(item) {
      this.legajoVer = item.legajo;
      this.showProde = true;
    },
  },
};
</script>

<style scoped>
.prode-mundial {
  max-width: 800px;
  margin: 0 auto;
}

.header-card {
  background: linear-gradient(135deg, #1a237e 0%, #0d47a1 50%, #01579b 100%) !important;
}

.grupo-btn {
  min-width: 32px !important;
  padding: 0 6px !important;
  font-size: 0.7rem !important;
  font-weight: 700;
}

.tabla-fixture th,
.tabla-fixture td {
  font-size: 0.72rem !important;
  padding: 4px 6px !important;
}
</style>
